import React, { useContext, useEffect } from 'react';
import { PageContext } from '@/context/PageContext';
import Helmet from 'react-helmet';

import Section from '@latitude/section';
import Layout from '@/components/layout';
import AchPageHeaderSection from './_ach-page-header';
import GemMicrositeHeader from '../_gem-microsite-header';

function AchLoginPage(props) {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */

  useEffect(() => {
        if (window?.location){
          window.location.replace('https://latitudefs.zendesk.com/hc/en-au/articles/36591875170577-Additional-Cardholders')
        }
      },[])

  return (
    <Layout location={props.location} hasSecNav>
      <main className="navigation-spacer">
        <Helmet>
          <link
            rel="canonical"
            href="https://www.latitudefinancial.com.au/credit-cards/gem-visa/addcard/login/"
          />
          <meta
            name="description"
            content="Add an additional cardholder to your Latitude Gem Visa card"
          />
          <title>Additional Card Holder Login | Gem Visa card</title>
        </Helmet>

        <AchPageHeaderSection />
        <GemMicrositeHeader data={state.secondaryNavData} />
        <Section>
          <div
            css={{ clear: 'both', margin: '10px 0' }}
            className="lfs-iframe-vixverify"
          >
            <iframe
              css={{
                width: '100%',
                height: '400px',
                border: 'none',
                padding: '10px'
              }}
              title="Set new password"
              src="https://au.vixverify.com/sa/customers/gecapital-ach/login.seam?ui=gemau"
            />
          </div>
        </Section>
      </main>
    </Layout>
  );
}

export default AchLoginPage;
